<div class="w-full p-10">
	<app-back-to-integrations-button></app-back-to-integrations-button>

	<div class="flex gap-8 py-8">
		<div
			class="w-48 h-48 flex-shrink-0 p-6 rounded-lg bg-gray-100 flex items-center justify-center"
		>
			<img class="w-full" src="/assets/images/leap/leap-logo-flush.png" />
		</div>

		<div>
			<h2>LEAP</h2>
			<p class="mt-6 text-gray-700">
				Access settings for the LEAP platform from within Closer. Merge Closer
				client list into LEAP as well as manage firm user access in this page.
			</p>
		</div>
	</div>

	<div class="w-full grid grid-cols-2 gap-8">
		<ui-section [uiColSpan]="2" title="Merge Client List">
			<i-tabler
				title-action
				name="info-circle"
				class="w-4 h-4 text-gray-500"
				matTooltip="This process will merge Closer clients into LEAP's client database. During the process, we will catch duplicate client entries which you are able to select and fix in the 'merge and fix' page when the merge is completed."
			></i-tabler>
			<div section-content>
				<div
					*ngIf="mergedClientsCount$ | async as mergedCount"
					class="grid grid-cols-4 gap-y-4 gap-x-10 w-fit"
				>
					<div class="grid-">Total Closer Clients</div>
					<div>
						{{
							(fetchingClientExportStatus$ | async)
								? 'Calculating total clients...'
								: mergedCount.totalClients
						}}
					</div>
					<div class="col-start-1">Added to LEAP</div>
					<div>
						{{
							(fetchingClientExportStatus$ | async)
								? 0
								: mergedCount.mergedClients
						}}
					</div>
					<div class="col-span-4 flex gap-4">
						<ui-button
							[label]="
								(fetchingClientExportStatus$ | async)
									? 'Fetching Client Numbers'
									: 'Merge Clients'
							"
							color="primary"
							[icon]="'arrows-exchange-2'"
							(click)="exportClientsToLeap()"
							[loading]="
								(clientMergeStatus$ | async) ===
								ClientMergeStatus.MERGING_IN_PROGRESS
							"
							[disabled]="!mergedCount.unmergedClients"
						></ui-button>

						<div
							class="flex items-center gap-2 text-gray-700"
							*ngIf="
								(clientMergeStatus$ | async) ===
								ClientMergeStatus.MERGING_IN_PROGRESS
							"
						>
							<i-tabler name="progress"></i-tabler>
							<span
								*ngIf="
									mergeInProgressClientsCount$ | async as mergeInProgressCount
								"
							>
								Merged {{ mergeInProgressCount.actualCount }}/{{
									mergeInProgressCount.expectedCount
								}}
								clients, please check back later
							</span>
						</div>

						<div
							class="flex items-center gap-2"
							*ngIf="
								(clientMergeStatus$ | async) === ClientMergeStatus.FULLY_MERGED
							"
						>
							<i-tabler name="check" class="text-green-600"></i-tabler>
							<span
								*ngIf="mergedClientsCount$ | async as mergedClientsCount"
								class="text-gray-700"
							>
								{{ mergedClientsCount.mergedClients }}/{{
									mergedClientsCount.totalClients
								}}
								clients merged in LEAP
							</span>
							<span
								class="text-green-600 underline cursor-pointer font-medium"
								(click)="goToClientsMergeReportPage()"
								>Check Client Merge Report</span
							>
						</div>

						<div
							class="flex items-center gap-2"
							*ngIf="
								(clientMergeStatus$ | async) ===
									ClientMergeStatus.PARTIALLY_MERGED &&
								(mergedClientsCount$ | async)?.clientsWithConflicts > 0
							"
						>
							<i-tabler name="alert-triangle" class="text-amber-500"></i-tabler>
							<span class="text-gray-700"> Duplicate clients found </span>
							<span
								class="text-green-600 underline cursor-pointer font-medium"
								(click)="goToFixClientsListPage()"
								>Fix Client List ({{
									(mergedClientsCount$ | async)?.clientsWithConflicts
								}})</span
							>
						</div>
					</div>
				</div>

				<div
					*ngIf="showMergeError$ | async"
					class="w-full flex justify-between mt-6 bg-red-50 rounded-md"
				>
					<div class="flex flex-col pt-4 mb-5 ml-5">
						<div class="flex items-center gap-2 pb-2">
							<i-tabler name="alert-triangle" class="text-red-500"></i-tabler>
							<span class="text-base font-medium">
								Close, But Let's Get Closer
							</span>
						</div>
						<p class="mt-2 text-sm font-normal">
							Almost got them all! But a few clients are refusing to budge. We
							merged as many as we could, but some didn't make the cut. Need
							help? Contact support!
						</p>
						<div class="mt-5">
							<button
								class="appearance-none bg-transparent border-none p-0 m-0 flex items-center gap-2 text-emerald-600"
								(click)="openIntercomPopup()"
							>
								<i-tabler name="headset"></i-tabler>
								<span class="font-medium text-base underline cursor-pointer"
									>Contact Support</span
								>
							</button>
						</div>
					</div>
					<div class="m-2">
						<ui-button
							icon="x"
							preset="ICON_DEFAULT"
							(click)="hideMergeError()"
						/>
					</div>
				</div>
			</div>
		</ui-section>

		<!-- TODO when designs available -->
		<!-- <ui-section [uiColSpan]="2" title="Invite firm users">			
			<i-tabler
				title-action
				name="info-circle"
				class="w-4 h-4 text-gray-500"
				matTooltip=""
			></i-tabler>
		</ui-section> -->

		<!-- <ui-section title="Resources">
            <a
                section-content
                class="flex gap-2 items-center cursor-pointer p-sm"
                externalNavInterceptor
                href="https://www.lawlabs.ca"
                target="_blank"
            >
                <i-tabler
                    name="external-link"
                    class="h-4 w-4 text-tealGreen-500"
                ></i-tabler>
                <span class="text-tealGreen-500 hover:underline duration-300"
                    >Lawlabs</span
                >
            </a>
        </ui-section> -->

		<!-- <ui-section title="Help">
            <a
                section-content
                class="flex gap-2 items-center cursor-pointer p-sm"
                externalNavInterceptor
                href="https://www.lawlabs.ca"
                target="_blank"
            >
                <i-tabler
                    name="external-link"
                    class="h-4 w-4 text-tealGreen-500"
                ></i-tabler>
                <span class="text-tealGreen-500 hover:underline duration-300"
                    >Lawlabs</span
                >
            </a>
        </ui-section> -->
	</div>
</div>
